import { ComplexEnumItem } from '../../utils/complexEnum/ComplexEnumItem'

export class IFIReportTypeItem<
  ID extends string,
  ClassType extends string,
  Label extends string,
  Type extends string,
  DefaultMessages extends Record<string, string>
> extends ComplexEnumItem<ID> {
  /**
   * the classType used to reference the record on the server
   */
  readonly classType: ClassType
  /**
   * the "human readable" name associated with {@link classType}
   */
  readonly type: Type
  /**
   * the property of the associated {@link classType} used to get the label associated
   * with a specific instance
   */
  readonly label: Label
  /**
   * a list of rules describing the conditions for the {@link classType} to be
   * imported into the IFI Tracker
   */
  readonly importRules: string[]
  /**
   * the default message to use for the description field in IFI's generated
   * by this {@link classType} in the IFI Tracker
   */
  readonly defaultMessages: DefaultMessages
  constructor({
    id,
    classType,
    label,
    type,
    importRules,
    defaultMessages,
  }: Pick<
    IFIReportTypeItem<ID, ClassType, Label, Type, DefaultMessages>,
    'id' | 'classType' | 'label' | 'type'
  > &
    Partial<
      Pick<
        IFIReportTypeItem<ID, ClassType, Label, Type, DefaultMessages>,
        'importRules' | 'defaultMessages'
      >
    >) {
    super(id)
    this.classType = classType
    this.label = label
    this.type = type
    this.importRules = importRules ?? []
    this.defaultMessages = defaultMessages ?? ({} as DefaultMessages)
  }
}
